export default "__VITE_ASSET__Bq8RQi91__"